<template>
	<div class="action-button-wrapper" v-if="site.connectionStatus==='0'">
      <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('reAddSite')">
          <span class="icon-cont">
              <readd-icon class="icon-default"></readd-icon>
          </span>
          <span>re-add site</span>
      </b-button>
  </div>
</template>

<script>
import ReaddIcon from '../../assets/readdsite.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	ReaddIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
  methods:{
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
  }
};
</script>